module.exports = __webpack_public_path__ + "img/creditCardPAY.43f1a4f3.svg";